import { render } from "./GMGeneralTab.vue?vue&type=template&id=2dc1818c&scoped=true"
import script from "./GMGeneralTab.vue?vue&type=script&lang=js"
export * from "./GMGeneralTab.vue?vue&type=script&lang=js"

import "./GMGeneralTab.vue?vue&type=style&index=0&id=2dc1818c&scoped=true&lang=scss"
import "./GMGeneralTab.vue?vue&type=style&index=1&id=2dc1818c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc1818c"],['__file',"src/views/Products/GMWorkFlow/GMGeneralTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dc1818c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dc1818c', __exports__)) {
    api.reload('2dc1818c', __exports__)
  }
  
  module.hot.accept("./GMGeneralTab.vue?vue&type=template&id=2dc1818c&scoped=true", () => {
    api.rerender('2dc1818c', render)
  })

}


export default __exports__